import React from 'react';
import { useData } from '../context/DataContext';
import { Card, CardHeader } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Table } from '../components/ui/Table';
import { Badge } from '../components/ui/Badge';
import { Company } from '../types';
import { formatPercent } from '../utils/calculations';
import { BuildingIcon, KeyIcon } from 'lucide-react';
export function Settings() {
  const {
    companies,
    taxRate,
    setTaxRate
  } = useData();
  const companyColumns = [{
    key: 'name',
    header: 'Company Name',
    render: (company: Company) => <div className="flex items-center gap-3" data-id="element-410">
          <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-411">
            <BuildingIcon className="w-5 h-5 text-blue-600" data-id="element-412" />
          </div>
          <span className="font-medium text-gray-900" data-id="element-413">{company.name}</span>
        </div>
  }, {
    key: 'id',
    header: 'Company ID',
    render: (company: Company) => <Badge variant="default" data-id="element-414">{company.id}</Badge>
  }, {
    key: 'stripe_key',
    header: 'Stripe Key',
    render: (company: Company) => <div className="flex items-center gap-2" data-id="element-415">
          <KeyIcon className="w-4 h-4 text-gray-400" data-id="element-416" />
          <code className="text-sm bg-gray-100 px-2 py-1 rounded" data-id="element-417">
            {company.stripe_key.slice(0, 12)}...
          </code>
        </div>
  }];
  return <div className="space-y-6" data-id="element-418">
      {/* Page Header */}
      <div data-id="element-419">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-420">Settings</h1>
        <p className="text-gray-500 mt-1" data-id="element-421">
          Manage your billing system configuration
        </p>
      </div>

      {/* Tax Settings */}
      <Card data-id="element-422">
        <CardHeader title="Tax Settings" subtitle="Configure default tax rate for invoices" data-id="element-423" />
        <div className="max-w-xs" data-id="element-424">
          <Input label="Default Tax Rate" type="number" min="0" max="1" step="0.01" value={taxRate} onChange={e => setTaxRate(parseFloat(e.target.value) || 0)} helperText={`Current rate: ${formatPercent(taxRate)} (Michigan default: 6%)`} data-id="element-425" />
        </div>
      </Card>

      {/* Companies */}
      <Card padding="none" data-id="element-426">
        <div className="p-6 border-b border-gray-200" data-id="element-427">
          <CardHeader title="Companies" subtitle="View configured companies and their Stripe keys" data-id="element-428" />
        </div>
        <Table columns={companyColumns} data={companies} keyExtractor={c => c.id} data-id="element-429" />
      </Card>

      {/* System Info */}
      <Card data-id="element-430">
        <CardHeader title="System Information" data-id="element-431" />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm" data-id="element-432">
          <div data-id="element-433">
            <span className="text-gray-500" data-id="element-434">Version</span>
            <p className="font-medium text-gray-900" data-id="element-435">1.0.0</p>
          </div>
          <div data-id="element-436">
            <span className="text-gray-500" data-id="element-437">Environment</span>
            <p className="font-medium text-gray-900" data-id="element-438">Test Mode</p>
          </div>
          <div data-id="element-439">
            <span className="text-gray-500" data-id="element-440">Stripe Fee</span>
            <p className="font-medium text-gray-900" data-id="element-441">2.9% + $0.30</p>
          </div>
          <div data-id="element-442">
            <span className="text-gray-500" data-id="element-443">Data Storage</span>
            <p className="font-medium text-gray-900" data-id="element-444">Local Storage</p>
          </div>
        </div>
      </Card>
    </div>;
}